var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-con"},[_c('div',{staticClass:"layout-license w-e-text",domProps:{"innerHTML":_vm._s(_vm.decs)}})])}
var staticRenderFns = []

export { render, staticRenderFns }